module.exports = __webpack_public_path__ + "static/media/home_slide_prev.d33f01a2.svg";